import React from 'react'

export default ({ steps, activeStep, onStepClick }) => {
	const _renderSteps = () => {
		const array = []
		for (let i = 1; i <= steps; i++) {
			array.push(i)
		}
		return array.map((step, i) => (
			<StepItem
				key={i}
				active={i + 1 === activeStep}
				onStepClick={onStepClick}
				index={i}
			/>
		))
	}

	return <div className={'stepper__container'}>{_renderSteps()}</div>
}

const StepItem = ({ active, onStepClick, index }) => {
	const _onStepClick = () => onStepClick(index + 1)
	return (
		<button className={'stepper__item'} onClick={_onStepClick}>
			<i
				className={`fas fa-circle ${
					active ? 'stepper__item-icon-active' : 'stepper__item-icon-inactive'
				}`}
			/>
		</button>
	)
}
